import { isNumber } from "@foretagsplatsen/core-helpers/number";
import numbroWithFailsafe from "./numbroWithFailsafe.js";

/**
 *
 * `ratio` is used to convert a ratio into
 * a pretty printed string.
 *
 * @return {function}
 */
function ratio() {
	const defaultFormat = ",0[.]00";

	const my = {};

	function that(number) {
		return my.format(number, defaultFormat);
	}

	that.withNumberOfDecimals = function (numberOfDecimals) {
		const format = ",0[.]".concat(new Array(numberOfDecimals + 1).join(0));
		return (number) => my.format(number, format);
	};

	my.format = function (number, formatName) {
		if (!isNumber(number)) {
			return "";
		}
		return `${numbroWithFailsafe(number).format(formatName)} x`;
	};

	return that;
}

export default ratio();
